import React from "react";
import { Heading } from "@americanexpress/dls-react";
import "./ContactUsStyle.css";
import { useTranslation, withTranslation } from "react-i18next";
import Header from "../Header/Header";

const ContactUs = (props) => {
  const { t, i18n } = useTranslation("common");
  i18n.changeLanguage(localStorage.getItem("lang"));

  return (
    <>
      <Header showlang={false} />
      <section id="contact-page" className="mainBodyStatic">
        <div className="ContactPage">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <Heading
                  level={1}
                  headingStyle={"heading5"}
                  className="margin-1-b"
                >
                  {t("contactUs.title")}
                </Heading>
                <hr className="margin-1-b" />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-3">
                <div className="privacyLinks">
                  <ul>
                    <li>
                      <a href={t("contactUs.australiaURL")} target="_blank">
                        {t("country.australia")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.hongkongURL")} target="_blank">
                        {t("country.hongkong")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.indiaURL")} target="_blank">
                        {t("country.india")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.JapanURL")} target="_blank">
                        {t("country.japan")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.newzealandURL")} target="_blank">
                        {t("country.newzealand")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.norwayURL")} target="_blank">
                        {t("country.norway")}
                      </a>
                    </li>

                  </ul>
                </div>
              </div>

              <div className="col-xs-3">
                <div className="privacyLinks">
                  <ul>

                    <li>
                      <a href={t("contactUs.singaporeURL")} target="_blank">
                        {t("country.singapore")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.swedenURL")} target="_blank">
                        {t("country.sweden")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.taiwanURL")} target="_blank">
                        {t("country.taiwan")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.thailandURL")} target="_blank">
                        {t("country.thailand")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.ukURL")} target="_blank">
                        {t("country.unitedKingdom")}
                      </a>
                    </li>

                    <li>
                      <a href={t("contactUs.iecURL")} target="_blank">
                        {t("country.iec")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default withTranslation("common")(ContactUs);
